export const COOKIES_KEYS = {
    CUSTOM_ERROR_MODAL: 'custom-error-modal',
};
